import React, { useEffect, useMemo } from "react";
import { Form, Modal } from "react-bootstrap";
import "../../Assets/css/myaccount.css";
import { Breadcrumbs, Typography } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { Col, Container, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import axios from "axios";
import { base_url, base_url_es } from "../../Helpers/request";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import Loader from "../../Components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { GetCountries, GetState, GetCity } from "react-country-state-city";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import "react-country-state-city/dist/react-country-state-city.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Setuser } from "../../Reducer/homeReducer";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";
import { Home } from "@material-ui/icons";

const Register = () => {
  const { t } = useTranslation();
  const language = useSelector((state) => state.persistedReducer.home.language);
  const history = useHistory();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState("1");
  const [firstname, setFirstname] = React.useState("");
  const [lastname, setLastname] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [address1, setAddress1] = React.useState("");
  const [address2, setAddress2] = React.useState("");
  const [postalcode, setPostalcode] = React.useState("");
  const [state, setState] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [city, setCity] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [viewPass, setViewPass] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const session_Id = useSelector(
    (state) => state.persistedReducer.home.session_id,
  );
  const [countriesList, setCountriesList] = React.useState([]);
  const [stateList, setStateList] = React.useState(null);
  const [cityList, setCityList] = React.useState(null);

  useEffect(() => {
    GetCountries().then((result) => {
      setCountriesList(result);
    });
  }, []);
  const submitRegister = (e) => {
    e.preventDefault();
    //setLoader(true);
    const data = {
      username: "",
      first_name: firstname,
      last_name: lastname,
      session_id: session_Id,
      email,
      phone,
      company,
      address1,
      address2,
      zip: postalcode,
      state,
      country,
      city,
      password,
    };
    if (password?.length <= 6) {
      swal(t("registerPage.passwordMinLength"), "", "error");
      return;
    }
    axios
      .post(
        (language === "es" ? base_url_es : base_url) + "/user/register",
        data,
        {
          headers: {
            // 'authorization':`Token e222085edc871220cae528152b73c1317ba2addf`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
      .then(async (response) => {
        if (response.data.status == 1) {
          setLoader(false);
          await swal(response.data.message, "", "success");
          var user = {
            token: response.data.data.token,
            user_id: response.data.data.user_id,
            email: response.data.data.email,
            first_name: response.data.data.first_name,
            last_name: response.data.data.last_name,
            isLogin: true,
          };
          dispatch(Setuser(user));
          window.location.replace("/account/myaccount");
        } else {
          setLoader(false);
          return swal(response.data.message, "", "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };
  const [statelable, setStatelable] = React.useState("Select State");
  const [citylable, setCitylable] = React.useState("Select City");
  const [ziplable, setZiplable] = React.useState("Postal Code");
  const [countryISOforContact, setCountryISOforContact] = React.useState("");

  const handleCountry = (countryData) => {
    setCountryISOforContact(countryData?.iso2?.toLowerCase());
    if (countryData?.iso2 == "US") {
      setStatelable("Select State");
      setCitylable("Select City");
      setZiplable("Zip Code");
    } else if (countryData?.iso2 == "PR" || countryData?.iso2 == "VI") {
      setStatelable("Select County");
      setCitylable("Select City");
      setZiplable("Zip Code");
    } else if (countryData?.iso2 == "GB") {
      setStatelable("Select County");
      setCitylable("Select City/Town");
      setZiplable("Postcode");
    } else if (countryData?.iso2 == "CA" || countryData?.iso2 == "AU") {
      setStatelable("Select Province");
      setCitylable("Select City");
      setZiplable("Postcode");
    } else if (countryData?.iso2 == "IN") {
      setStatelable("Select State");
      setCitylable("Select City");
      setZiplable("Pin Code");
    } else {
      setStatelable("Select State/ Province/ Region");
      setCitylable("Select City");
      setZiplable("Postcode");
    }
  };

  const countryISOforContactVal = useMemo(
    () => countryISOforContact,
    [countryISOforContact],
  );

  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_myaccount_section">
        <Container>
          <Row>
            <Col className="rcs_breadcrumb mb-2">
              <Breadcrumbs aria-label="breadcrumb">
                <NavLink underline="hover" color="inherit" to="/">
                  <Home />
                </NavLink>
                <Typography color="text.primary">Register</Typography>
              </Breadcrumbs>
            </Col>
          </Row>
          <Row>
            <Col>
              <din className="rcs_top_heading">
                <h1>{t("registerPage.RegAccount")}</h1>
              </din>
            </Col>
          </Row>
          <Row className="rcs_tab_section m-auto w-100">
            <Col className="p-0">
              <div className="rcs_register_content mt-2 pt-2">
                <Row className="m-auto w-100">
                  <Col xs={12} sm={8} md={4}>
                    <div class="alert alert-info text-left d-flex">
                      {" "}
                      <InfoOutlinedIcon />{" "}
                      <span>{t("registerPage.enterInfo")}</span>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={8} className="p-0">
                    <div className="rcs_account_content_left">
                      <Form onSubmit={submitRegister}>
                        <Row>
                          <Col xs={12} sm={6} className="rcs_custom_padding">
                            <TextField
                              id="outlined-basic"
                              label="First Name"
                              type="text"
                              variant="outlined"
                              value={firstname}
                              onChange={(e) => setFirstname(e.target.value)}
                              required
                            />
                          </Col>
                          <Col xs={12} sm={6} className="rcs_custom_padding">
                            <TextField
                              id="outlined-basic"
                              label="Last Name"
                              type="text"
                              variant="outlined"
                              value={lastname}
                              onChange={(e) => setLastname(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} sm={6} className="rcs_custom_padding">
                            <TextField
                              id="outlined-basic"
                              label="Email Address"
                              type="Email"
                              variant="outlined"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </Col>
                          <Col xs={12} sm={6} className="rcs_custom_padding">
                            {/* <TextField
                              id="outlined-basic"
                              label="Phone"
                              type="number"
                              variant="outlined"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                              InputProps={{ inputProps: { min: 0 } }}
                              required
                            /> */}
                            <PhoneInput
                              country={"es"}
                              //country={countryISOforContactVal}
                              className="w-100 border-0"
                              value={phone}
                              onChange={(
                                val,
                                countryDetails,
                                e,
                                formattedVal,
                              ) => {
                                setPhone(formattedVal);
                              }}
                              required
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} className="rcs_custom_padding">
                            <TextField
                              id="outlined-basic"
                              label="Company"
                              type="text"
                              variant="outlined"
                              value={company}
                              onChange={(e) => setCompany(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} className="rcs_custom_padding">
                            <TextField
                              id="outlined-basic"
                              label="Address Line 1"
                              type="text"
                              variant="outlined"
                              value={address1}
                              onChange={(e) => setAddress1(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} className="rcs_custom_padding">
                            <TextField
                              id="outlined-basic"
                              label="Address Line 2"
                              type="text"
                              variant="outlined"
                              value={address2}
                              onChange={(e) => setAddress2(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} sm={12} className="rcs_custom_padding">
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label id_country">
                                Select Country
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="id_country"
                                label="Select Country"
                                required
                                //   className={style.register_inp}
                                value={country}
                                onChange={(e) => {
                                  const country1 = countriesList?.filter(
                                    (val) => val.name == e.target.value,
                                  ); //here you will get full country object.
                                  handleCountry(country1[0]);
                                  setCountry(e.target.value);
                                  if (e.target.value == "") {
                                    setStateList(null);
                                    setCityList(null);
                                    setState("");
                                    setCity("");
                                  } else {
                                    GetState(country1[0]?.id).then((result) => {
                                      setStateList(result);
                                      setCityList(result.length ? null : []);
                                    });
                                  }
                                }}
                              >
                                {countriesList?.map((item, index) => (
                                  <MenuItem ekey={index} value={item.name}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Col>
                        </Row>
                        <Row>
                          {stateList == null || stateList?.length ? (
                            <Col xs={12} sm={12} className="rcs_custom_padding">
                              <FormControl fullWidth>
                                <InputLabel id="id_state">
                                  {statelable}
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  label={statelable}
                                  value={state}
                                  required={stateList?.length}
                                  onChange={(e) => {
                                    const country1 = countriesList?.filter(
                                      (val) => val.name == country,
                                    );
                                    const state1 = stateList?.filter(
                                      (val) => val.name == e.target.value,
                                    );
                                    setState(e.target.value);
                                    if (e.target.value == "") {
                                      setCityList(null);
                                      setCity("");
                                    } else {
                                      GetCity(
                                        country1[0]?.id,
                                        state1[0]?.id,
                                      ).then((result) => {
                                        setCityList(result);
                                      });
                                    }
                                  }}
                                >
                                  {stateList?.map((item, index) => (
                                    <MenuItem key={index} value={item.name}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                          ) : (
                            ""
                          )}
                          {cityList == null || cityList?.length ? (
                            <Col xs={12} sm={12} className="rcs_custom_padding">
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label id_city">
                                  {citylable}
                                </InputLabel>
                                <Select
                                  label={citylable}
                                  onChange={(e) => {
                                    setCity(e.target.value);
                                  }}
                                  value={city}
                                  required={cityList?.length}
                                >
                                  {cityList?.map((item, index) => (
                                    <MenuItem key={index} value={item.name}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                          ) : (
                            ""
                          )}

                          <Col xs={12} sm={6} className="rcs_custom_padding">
                            <TextField
                              id="outlined-basic"
                              label={ziplable}
                              type={ziplable == "Postcode" ? "text" : "number"}
                              variant="outlined"
                              value={postalcode}
                              onChange={(e) => setPostalcode(e.target.value)}
                              required
                              InputProps={{ inputProps: { min: 0 } }}
                            />
                          </Col>
                          <Col xs={12} sm={6} className="rcs_custom_padding">
                            <TextField
                              id="outlined-basic"
                              label="Desired Password"
                              //type="password"
                              variant="outlined"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                              type={viewPass ? "text" : "password"}
                              helperText={
                                password?.length <= 6
                                  ? t("registerPage.passwordMinLength")
                                  : t("registerPage.passwordMinLength")
                              }
                              error={password && password?.length <= 6}
                            />
                            <span
                              className="passwordShowHide"
                              onClick={() => setViewPass(!viewPass)}
                            >
                              {viewPass ? <FiEye /> : <FiEyeOff />}{" "}
                            </span>
                          </Col>
                        </Row>
                        <Row></Row>
                        <Row>
                          <Col
                            className="rcs_custom_padding"
                            sm={{ span: "4", offset: "4" }}
                          >
                            <Button
                              variant="contained"
                              type="submit"
                              className="rcs_acc_button"
                              style={{ margin: "0 auto", display: "block" }}
                            >
                              {t("registerPage.Register")}
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal show={loader}>
        <Loader />
      </Modal>
    </>
  );
};

export default Register;
